import {
    CHECK_ACCESS_TOKEN,
    SET_ACCESS_TOKEN,
    CLEAR_ACCESS_TOKEN,
} from '../../actions'

const initialState = {
    access_token: undefined,
    client_id: undefined,
}

const token = (state = initialState, action) => {
    switch (action.type) {
        case CHECK_ACCESS_TOKEN:
            return state;
        case SET_ACCESS_TOKEN:
            return {
                ...action.payload.user,
            };
        case CLEAR_ACCESS_TOKEN:
            return initialState;

        default:
            return state
    }
}

export default token



// WEBPACK FOOTER //
// ./src/reducers/account/token.js